import { Button, HStack } from 'components/ui';
import { SVG } from 'components/svg';
import { Icons } from 'assets';
import { useAiEditorContext } from '../ai-editor.context';

type AiEditorFooterProps = {
  onClose: () => void;
  onApply: () => void;
};

export const AiEditorFooter = ({ onClose, onApply }: AiEditorFooterProps) => {
  const { activeMode, result, isGenerating, handleGenerate } =
    useAiEditorContext();

  if (result) {
    return (
      <HStack spacing="xs" justify="flex-end">
        <Button mode="neutral" onClick={onClose}>
          Отмена
        </Button>

        <Button mode="accent" onClick={onApply}>
          Применить
        </Button>
      </HStack>
    );
  }

  return (
    <HStack spacing="xs" justify="flex-end">
      {!isGenerating && (
        <Button
          leftIcon={<SVG src={Icons.AiGenerate} />}
          mode="additional"
          pending={isGenerating}
          onClick={handleGenerate}
        >
          {activeMode?.generateButtonText ?? 'Сгенерировать'}
        </Button>
      )}
    </HStack>
  );
};
